// Only the AI upload is resized. Preview/crop keep the original File.
export async function prepareAISearchImage(file, signal) {
  const aborted = () => {
    if (signal?.aborted) throw new DOMException('Search cancelled', 'AbortError');
  };
  aborted();
  // Avoid extra decode/encode work for already-small uploads.
  if (file.size <= 256 * 1024 || !/^image\/(jpeg|png|webp)$/i.test(file.type)) return file;
  const url = URL.createObjectURL(file);
  const image = new Image();
  let canvas;
  try {
    await new Promise((resolve, reject) => {
      const cleanup = () => {
        image.onload = image.onerror = null;
        signal?.removeEventListener('abort', cancel);
      };
      const cancel = () => {
        cleanup(); image.src = '';
        reject(new DOMException('Search cancelled', 'AbortError'));
      };
      image.onload = () => { cleanup(); resolve(); };
      image.onerror = () => { cleanup(); reject(new Error('IMAGE_DECODE_FAILED')); };
      signal?.addEventListener('abort', cancel, { once: true });
      if (signal?.aborted) { cancel(); return; }
      image.src = url;
    });
    aborted();
    const width = image.naturalWidth, height = image.naturalHeight;
    if (!width || !height || width * height > 25000000) return file;
    const scale = Math.min(1, 1024 / Math.max(width, height));
    canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(width * scale));
    canvas.height = Math.max(1, Math.round(height * scale));
    const context = canvas.getContext('2d');
    if (!context || !canvas.toBlob) return file;
    // Same white alpha background as engine.read_image; browser honors EXIF.
    context.fillStyle = '#fff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.85));
    aborted();
    return blob && blob.size > 0 && blob.size < file.size ? blob : file;
  } catch (error) {
    if (error.name === 'AbortError' || signal?.aborted) {
      throw new DOMException('Search cancelled', 'AbortError');
    }
    // Unsupported canvas/encoding must not break the existing upload flow.
    return file;
  } finally {
    URL.revokeObjectURL(url);
    if (canvas) { canvas.width = 0; canvas.height = 0; }
  }
}
